export default __webpack_public_path__ + "static/media/lab_32.e97d3b20.png";